<template>
  <div
    class="templateTwo"
    v-lazy:background-image="{
      src: data.bg,
    }"
    :style="{ backgroundColor: data.bgColor }"
  >
    <title-widge
      :title="data.title"
      :subTitle="data.subTitle"
      :titleColor="titleColor"
      :subTitleColor="subTitleColor"
      :fontBg="fontBg"
      :fontBgColor="fontBgColor"
    ></title-widge>
    <div class="divImg">
      <img v-lazy="data.url" />
    </div>
  </div>
</template>

<script>
import titleWidge from "./../../ai/components/titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "rgba(8,46,124,1)",
    },
    subTitleColor: {
      type: String,
      default: "rgba(109,109,109,1)",
    },
    fontBg: {
      type: String,
      default: "02",
    },
    fontBgColor: {
      type: String,
      default: "rgba(10,226,242,1)",
    },
    bgColor: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.templateTwo {
  padding-bottom: 86px;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  .divImg {
    width: 1120px;
    margin: 0 auto;
    img {
      width: 1120px;
    }
  }
}
</style>
